import { ChatAPI, setChatLoading } from '@guuru/chat-web';

export default {
  validate() {
    return true;
  },
  render() {
    setChatLoading(false);
    ChatAPI.initChat([]);

    return { goToNextStep: true };
  },
};
